// extracted by mini-css-extract-plugin
export default {"hovered":"fb_hovered__ZZ8cW","bw_circle":"fb_bw_circle__pKr24","bw_stars":"fb_bw_stars__CsVDg","stars":"fb_stars__KvRQI"};